// extracted by mini-css-extract-plugin
module.exports = {"container":"TariffsTableBlock_container__9jxfg","tableContainer":"TariffsTableBlock_tableContainer__mRH0h"};